import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import QuizItem from "./QuizItem";
import { useSubmitQuizMutation } from "../../../features/quizMark/quizMarkApi";
import { useGetQuizesByVideoIdQuery } from "../../../features/quiz/quizApi";
import EmptyResult from "../../ui/EmptyResult";
import Loading from "../../ui/Loading";
import Error from "../../ui/Error";
import MessageToast from "../../ui/MessageToast";

export default function Quizzes() {
	const { id: studentId, name: studentName } = useSelector(
		(state) => state.auth.user
	);
	const navigate = useNavigate();
	const { videoId } = useParams();
	const {
		data: quizzes,
		isLoading,
		isError,
	} = useGetQuizesByVideoIdQuery(videoId) || {};

	const [quizAnswers, setQuizAnswers] = useState([]);

	const handleQuizResult = (quizAnswer) => {
		let quiz = quizAnswers.find((q) => q.id === quizAnswer.quizId);
		if (quiz === undefined) {
			setQuizAnswers([
				...quizAnswers,
				{ id: quizAnswer.quizId, score: quizAnswer.score },
			]);
		} else {
			let otherData = quizAnswers.filter(
				(q) => q.id !== quizAnswer.quizId
			);
			setQuizAnswers([
				...otherData,
				{ id: quizAnswer.quizId, score: quizAnswer.score },
			]);
		}
	};

	const [
		submitQuiz,
		{ isSuccess: isQuizeSubmitSuccess, isError: isQuizSubmitError },
	] = useSubmitQuizMutation() || {};

	const handleQuizSubmit = () => {
		const totalScore = quizAnswers.reduce((prev, qa) => prev + qa.score, 0);
		const totalQuiz = quizzes?.length;
		const perQuestionMark = 5;
		const totalCorrect = totalScore / perQuestionMark;

		let quizData = {
			student_id: studentId,
			student_name: studentName,
			video_id: quizzes[0].video_id,
			video_title: quizzes[0].video_title,
			totalQuiz: totalQuiz,
			totalCorrect: totalCorrect,
			totalWrong: totalQuiz - totalCorrect,
			totalMark: totalQuiz * perQuestionMark,
			mark: totalCorrect * perQuestionMark,
		};

		submitQuiz(quizData);
	};

	useEffect(() => {
		if (isQuizeSubmitSuccess) {
			navigate("/leaderboard");
		}
	}, [isQuizeSubmitSuccess, navigate]);

	// Decide what to render
	let content = null;
	if (isLoading) {
		content = <Loading />;
	} else if (!isLoading && isError) {
		content = <Error message="There was an error!" />;
	} else if (!isLoading && !isError && quizzes?.length === 0) {
		content = <EmptyResult contentName="quizzes" />;
	} else if (!isLoading && !isError && quizzes?.length > 0) {
		content = (
			<>
				<div className="mb-8">
					<h1 className="text-2xl font-bold">
						{quizzes[0].video_title}
					</h1>
					<p className="text-sm text-slate-200">
						Each question contains 5 Mark
					</p>
				</div>
				<div className="space-y-8 ">
					{quizzes.map((quiz) => (
						<QuizItem
							key={quiz.id}
							quiz={quiz}
							resultHandler={handleQuizResult}
						/>
					))}
				</div>
				<button
					onClick={handleQuizSubmit}
					className="px-4 py-2 rounded-full bg-cyan block ml-auto mt-8 hover:opacity-90 active:opacity-100 active:scale-95 "
				>
					Submit
				</button>
			</>
		);
	}

	return (
		<section className="py-6 bg-primary">
			<div className="mx-auto max-w-7xl px-5 lg:px-0">{content}</div>
			{isQuizSubmitError && (
				<MessageToast
					message="There was an error while submitting quizzes!"
					type="error"
					delay={3000}
				/>
			)}
		</section>
	);
}
